import { Component, input, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { GuideFrameService } from "../../services/guide-frame.service";

@Component({
    selector: "frame-window",
    templateUrl: "./frame-window.component.html",
    styleUrls: ["./frame-window.component.scss"],
    host: {
        style: "display:contents",
    },
    standalone: false
})
export class FrameWindowComponent implements OnInit {
  iframeUrl = input<string>();

  safeUrl: SafeUrl | undefined;

  state: "max" | "default";
  constructor(
    private sanitizer: DomSanitizer,
    private _guideFrameService: GuideFrameService
  ) {
    this.state = "max";
  }

  ngOnInit(): void {
    this.generateSafeUrl();
  }

  private generateSafeUrl() {
    const currentFrameUrl = this.iframeUrl(); 
    if (!currentFrameUrl) return;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      currentFrameUrl
    );
  }

  handleCloseGuide() {
    this._guideFrameService.deactivateHelpGuide();
  }
  handleWindowSize() {
    this.state = this.state === "max" ? "default" : "max";
  }
  handleOpenNewWindow() {
    const currentFrameUrl = this.iframeUrl()
    if (!currentFrameUrl) return;
    this._guideFrameService.deactivateHelpGuide();
    window.open(currentFrameUrl);
  }
}
